import { takeEvery, put, fork, call, all /*select*/ } from 'redux-saga/effects';
import { actions as deptReducerActions, callTypes as deptReducerCallTypes } from "./departmentSlice"
import { getAllDeptsApi, searchDeptsApi } from "./departmentAPI";
import * as uis from "../../../UI/redux/uiSlice";

export function* onLoadDepartmentsStartAsync({payload}){

    try{
        
        yield put(deptReducerActions.startCall({ callType: deptReducerCallTypes.list }));

        // const getAuth = (state) => state.auth;
        // const auth = yield select(getAuth);
        
        // let reqBody = {
        //     username: "guest",
        //     sessionkey: auth.sessionKey,
        // };

        // const response = yield call(getAllDeptsApi, reqBody);
        
        const response = yield call(getAllDeptsApi, payload.query.provinceId);        

        if(response.status === 200){
            let entities = response.data ? response.data : [];
            let totalCount = entities.length;
            yield put(deptReducerActions.deptsLoaded({entities, totalCount}));
        }
    }
    catch(error){

        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: "There was an error retrieving the departments."
        // }));

        yield put(deptReducerActions.catchError({
            callType: deptReducerCallTypes.list,
            error: "There was an error retrieving the departments."
        }));

    }

};

export function* onSearchDepartmentsStartAsync({payload}){

    try{
        
        yield put(deptReducerActions.startCall({ callType: deptReducerCallTypes.list }));

        // const getAuth = (state) => state.auth;
        // const auth = yield select(getAuth);

        // let reqBody = {
        //     username: auth.userName,
        //     sessionKey: auth.sessionKey,
        //     string: payload.query
        // };

        // const response = yield call(searchDeptsApi, reqBody); 

        let reqBody = { 
            idOne: payload.provId,
            str: payload.query.str 
        };

        const response = yield call(searchDeptsApi, reqBody);        
        
        if(response.status === 200){
            let entities = response.data;
            let totalCount = entities.length;
            yield put(deptReducerActions.deptsLoaded({entities, totalCount}));
        }
    }
    catch(error){

        if(error.response.status === 403){

            let status = error.response.status;
            let msg = "Forbidden. You do not have access to view this page.";

            yield put(uis.actions.error({ status, msg }));
            
        } else if(error.response.status === 404){

            let status = error.response.status;
            let msg = "Page Not Found.";

            yield put(uis.actions.error({ status, msg }));
        } else if(error.response.status === 500){

            let status = error.response.status;
            let msg = "Internal Error";

            yield put(uis.actions.error({ status, msg }));
        }

        // yield put(uis.actions.showNotification({
        //     status:"error",
        //     title:"Error",
        //     message: "There was an error while searching for the departments."
        // }));

        yield put(deptReducerActions.catchError({
            callType: deptReducerCallTypes.list,
            error: "There was an error while searching for the departments."
        }));

    }

};

export const actionTypes = {
    FetchDeptsInProv: "[FetchDeptsInProv] Fetch Depts In Prov API Action",
    SearchDepts: "[SearchDepts] Search Depts API Action",
};

export const actions = {

    fetchDeptsInProv: (query) => ({ type: actionTypes.FetchDeptsInProv, payload: { query } }),
    searchDepts: (query, provId) => ({ type: actionTypes.SearchDepts, payload: { query, provId } }),

};

export function* fetchDeptsInProv(){

    yield takeEvery(actionTypes.FetchDeptsInProv,onLoadDepartmentsStartAsync);    
};

export function* searchDepts(){

    yield takeEvery(actionTypes.SearchDepts,onSearchDepartmentsStartAsync);    
};


const fSagas = [
    fork(fetchDeptsInProv),
    fork(searchDepts),

];

export function* saga(){
    yield all ([...fSagas]);
};
